import React, { useState } from "react";
import OperationsPage from "./OperationsPage";
import { MonthNavigator } from "../../components/shared/Navigators";

const STATUS = ["Not Started", "In Progress", "Follow-Up Needed", "Completed", "Cancelled", "Rescheduled", "No-Show", "Waiting on Response"];
const PRIORITY = ["Normal", "Priority"];
const TYPES = ["Referral", "Networking", "Partnership", "Vendor Introduction", "Realtor Introduction", "Lender Introduction", "Investor Introduction", "Business Opportunity", "Collaboration", "General Introduction"];

const FIELDS = [
  { name: "date", label: "Date", type: "date" },
  { name: "name", label: "Name" },
  { name: "company", label: "Company" },
  { name: "email", label: "Email" },
  { name: "phone", label: "Phone" },
  { name: "introduced_name", label: "Introduced Name" },
  { name: "introduced_company", label: "Introduced Company" },
  { name: "introduced_email", label: "Introduced Email" },
  { name: "introduced_phone", label: "Introduced Phone" },
  { name: "affiliation", label: "Affiliation" },
  { name: "type", label: "Introduction Type", type: "select", options: TYPES },
  { name: "notes", label: "Note(s)", type: "textarea", full: true },
  { name: "follow_up", label: "Follow Up", full: true },
  { name: "follow_up_date", label: "Follow Up Date", type: "date" },
  { name: "outcome", label: "Outcome" },
  { name: "referral_potential", label: "Referral Potential" },
  { name: "status", label: "Status", type: "select", options: STATUS },
  { name: "priority", label: "Priority", type: "select", options: PRIORITY },
];

const CATS = [
  { key: "Professional Introductions - Given", color: "#46A758", fields: FIELDS },
  { key: "Professional Introductions - Received", color: "#0090FF", fields: FIELDS },
].map((c) => ({ ...c, label: c.key }));

// Same column set for BOTH Given and Received so the headings stay aligned.
const COLUMNS = [
  { key: "date", label: "Date", className: "font-mono-rw text-xs" },
  { key: "name", label: "Name" },
  { key: "company", label: "Company" },
  { key: "email", label: "Email", className: "font-mono-rw text-xs" },
  { key: "phone", label: "Phone", className: "font-mono-rw text-xs" },
  { key: "introduced_name", label: "Introduced" },
  { key: "introduced_company", label: "Introduced Co." },
  { key: "introduced_email", label: "Intro. Email", className: "font-mono-rw text-xs" },
  { key: "introduced_phone", label: "Intro. Phone", className: "font-mono-rw text-xs" },
  { key: "follow_up", label: "Follow-up" },
  { key: "status", label: "Status" },
  { key: "priority", label: "Pri." },
];

export default function ProfessionalIntroductions() {
  const now = new Date();
  const [value, setValue] = useState(`${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`);
  return (
    <OperationsPage
      kind="intros"
      title="Professional Introductions"
      eyebrow="Operations"
      dot="var(--rw-dot-intros)"
      description="Introductions given and received, tracked month-by-month."
      scope={{
        type: "month",
        value,
        setValue,
        Navigator: <MonthNavigator value={value} onChange={setValue} />,
      }}
      defaultCategories={CATS}
      getFieldsFor={() => FIELDS}
      columns={COLUMNS}
    />
  );
}
